"use client";
import React from "react";
import dynamic from 'next/dynamic'
const MainPoster = dynamic(() => import('@/components/mainposter'),{ssr:false})

export default function TermsConditions() {

  return (
    <>
      <MainPoster
        bgimg="/assets/images/my-cart/bg/bg-poster.webp"
        title="Terms & Conditions"
        type="pathes"
        main="Home"
        mainhref="/"
        sub="Terms & Conditions"
        subhref="/terms-conditions"
      />

      <section className="section-py blog-bg-poster privacy-policy">
        <div className="container-main mx-auto px-3">
          <h2 className="fw-medium mb-4">Terms & Conditions</h2>

          <h3 className="mt-4 fw-medium">1. Introduction</h3>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus
            convallis, urna a fermentum vulputate, justo purus laoreet ante, nec
            lacinia felis orci id velit. Integer sagittis, sapien eu malesuada
            faucibus, urna quam convallis arcu, ac blandit erat velit a arcu.
          </p>

          <h3 className="mt-4 fw-medium">2. Use of the Site</h3>
          <p>
            Aenean fermentum, quam non faucibus facilisis, turpis arcu consequat
            purus, eu tincidunt mauris neque at erat. Proin vestibulum, libero vel
            suscipit fermentum, arcu ligula dapibus massa, nec faucibus felis purus
            non turpis. Suspendisse tincidunt fringilla tortor, sit amet dignissim
            arcu feugiat at.
          </p>

          <h3 className="mt-4 fw-medium">3. User Responsibilities</h3>
          <p>
            Mauris gravida, justo nec vulputate efficitur, nisi ex feugiat lectus,
            non bibendum augue nulla ut velit. Sed vehicula, purus a convallis
            luctus, tellus nunc iaculis nisi, in condimentum mi sapien eget sem.
            Nullam dapibus magna ut metus tincidunt, vel ornare arcu gravida.
          </p>

          <h3 className="mt-4 fw-medium">4. Intellectual Property</h3>
          <p>
            Aliquam erat volutpat. Integer ut sem sed enim iaculis feugiat.
            Vestibulum nec tincidunt libero. Duis vel sem vel lorem sollicitudin
            cursus. Nulla facilisi. Nam sit amet justo non est tempor rutrum. Cras
            bibendum lacus nec velit sodales, vitae gravida elit dictum.
          </p>

          <h3 className="mt-4 fw-medium">5. Third-Party Links</h3>
          <p>
            Fusce finibus, nibh non egestas consequat, ex purus rutrum ipsum, id
            tincidunt felis diam ac eros. Maecenas eu tincidunt purus. Nulla
            facilisi. Ut vitae lobortis metus. Aenean sit amet odio nec ipsum
            luctus tincidunt.
          </p>

          <h3 className="mt-4 fw-medium">6. Limitation of Liability</h3>
          <p>
            Etiam eu turpis in sem pretium laoreet. Quisque at turpis non lacus
            rutrum faucibus. Pellentesque nec sapien blandit, fermentum lectus
            eget, ultricies velit. In hac habitasse platea dictumst. Sed accumsan
            malesuada lorem, a fringilla mi ultrices ac.
          </p>

          <h3 className="mt-4 fw-medium">7. Termination</h3>
          <p>
            Suspendisse sed turpis fringilla, blandit sapien in, cursus risus.
            Morbi malesuada, nunc et mattis porttitor, magna augue rutrum dolor, ac
            malesuada erat lacus sed sapien. Pellentesque eu diam sed elit
            hendrerit tempor non et neque.
          </p>

          <h3 className="mt-4 fw-medium">8. Governing Law</h3>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque sit
            amet fermentum sem. Mauris vitae sapien id nisi hendrerit finibus in
            vitae lacus. Etiam sed sem in eros blandit convallis. Curabitur id
            lacus sit amet est faucibus rutrum.
          </p>

          <h3 className="mt-4 fw-medium">9. Modifications to Terms</h3>
          <p>
            Nam viverra fringilla dui a fringilla. Donec vel sagittis elit. In
            feugiat, arcu nec interdum eleifend, ligula erat varius mauris, nec
            tempus turpis arcu eget ligula. Curabitur condimentum orci felis, at
            posuere purus aliquam vel.
          </p>

          <h3 className="mt-4 fw-medium">10. Contact Information</h3>
          <p>
            If you have any questions about these terms, please contact us at{" "}
            <a href="mailto:info@example.com">info@example.com</a>. Vivamus
            suscipit, sapien et posuere placerat, sapien diam tincidunt lorem, in
            dictum libero risus vitae metus.
          </p>
        </div>
      </section>
    </>
  );
}
